import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import * as userApi from '../../../lib/api/user';

const UsrSelectbox = (props) => {
  const { id, value, api, field, name } = props;
  const [open, setOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const loading = open && options.length === 0;

  useEffect(() => {
    fetchData();
  }, [loading]);

  const fetchData = async () => {
    try {
      const res = await userApi.getUsers();

      if (res.data.list) {
        setOptions(res.data.list);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = async (event) => {
    api.setEditCellValue({ id, field, value: event.target.value }, event);
    // Check if the event is not from the keyboard
    // https://github.com/facebook/react/issues/7407
    // if (event.nativeEvent.clientX !== 0 && event.nativeEvent.clientY !== 0) {
    //   await api.commitCellChange({ id, field });
    //   api.setCellMode(id, field, 'view');
    // }
    // if (event.type === 'click' && event.clientX !== 0 && event.clientY !== 0) {
    //   await api.commitCellChange({ id, field });
    //   api.setCellMode(id, field, 'view');
    // }
  };

  const handleRef = (element) => {
    // console.log(element, 'element');
    if (element) {
      //element.querySelector(`input[value="${value}"]`).focus();
      element.querySelector(`select[name="${name}"] option:checked`);
    }
  };

  return (
    <TextField
      name={name}
      ref={handleRef}
      select
      fullWidth
      value={value}
      onChange={handleChange}
    >
      {options.map((option, index) => (
        // <MenuItem key={index} value={option.usrUuid}>
        //   {option.usrNm} {option.gradeNm}
        // </MenuItem>
        <MenuItem key={index} value={option.usrUuid}>
          <Box sx={{display:'flex',flexDirection: 'row',flexWrap: 'wrap'}}>
          <Box sx={{ flexShrink: 0 }}>
              {option?.profileImg !== null && option?.profileImg !== '' ? (
                <Avatar alt={option?.usrNm} src={option?.profileImg} />
              ) : (
                <Avatar>
                  {option.usrNm ? option?.usrNm.substring(0, 1) : ''}
                </Avatar>
              )}
            </Box>
            <Box sx={{ flexGrow: 1, ml: 1 }}>
              <Typography variant="subtitle2">
                {option?.usrNm} {option?.gradeNm}
              </Typography>
              <Typography variant="body2">
                {option?.dptNm}
              </Typography>
            </Box>

          </Box>
        </MenuItem>
      ))}
    </TextField>
  );
};

UsrSelectbox.propTypes = {
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.string]).isRequired,
  /**
   * The cell value, but if the column has valueGetter, use getValue.
   */
  value: PropTypes.string.isRequired,
};

export default UsrSelectbox;
